// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page Chiffrage (prestataire) : composition d'un devis pre-etabli, INLINE (pleine page). Palette
   fermee du design system : headers #595959, primaire #f97316, texte #374151. Echelle 1rem = 10px. */

.chiffrage-page {
  width: 100%;
  padding: 2rem;
  color: #374151;
}

/* En-tete : titre + retour. */
.chiffrage-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin: 2rem 0 1.5rem;
}

.chiffrage-title {
  margin: 0;
  font-size: 2.2rem;
  font-weight: 700;
  color: #595959;
}

.chiffrage-feedback {
  margin: 1.5rem 0;
}

/* Ligne du haut (mockup) : rappel en lecture seule des lots retenus (a gauche) + actions de la page
   (a droite : nouveau chiffrage, reprise d'un chiffrage en cours, acces a tous les chiffrages). */
/* Rangee unique : les 3 champs ET les 3 actions. \`align-items: flex-end\` cale les actions au niveau
   des CHAMPS et non des labels (les champs sont des colonnes label + controle). Plus de
   \`justify-content: space-between\` : il ecartait les deux anciens sous-groupes en deux blocs. */
.chiffrage-toolbar {
  display: flex;
  align-items: flex-end;
  gap: 1.2rem;
  flex-wrap: wrap;
  margin: 1.5rem 0;
}

/* ---------------------------------------------------------------------------------------------
   Table des articles. Les classes viennent du BC (\`.articles-table-*\`), mais son ALIGNEMENT est
   scope a la page cote BC (\`.opbc …\` dans SuiviOperationBCV2.css) — rien ne s'appliquait donc ici,
   d'ou des en-tetes desynchronises du contenu. Ce scope est deliberatif dans ce projet : chaque page
   cale ses propres colonnes (\`.opbc\`, \`.scbc\`…). On suit la convention, avec les MEMES colonnes.
   --------------------------------------------------------------------------------------------- */
.chiffrage-page .articles-table-wrapper {
  overflow-x: hidden;
}

.chiffrage-page .articles-table-wrapper th,
.chiffrage-page .articles-table-wrapper td {
  overflow-wrap: break-word;
}

/* Les MEMES regles frappent thead ET tbody : l'en-tete ne peut donc pas se desynchroniser de son
   contenu, et ca surclasse la regle globale qui forcait les en-tetes a gauche. Vaut pour la table en
   lecture seule (6 colonnes) comme editable (7, +Actions).
   col1 N°Ref + col2 Description = gauche ; col3 Unite + col4 Quantite + col7 Actions = centre ;
   col5 Prix + col6 Total = droite. */
.chiffrage-page .articles-table-wrapper th:nth-child(1),
.chiffrage-page .articles-table-wrapper td:nth-child(1),
.chiffrage-page .articles-table-wrapper th:nth-child(2),
.chiffrage-page .articles-table-wrapper td:nth-child(2) {
  text-align: left;
}

.chiffrage-page .articles-table-wrapper th:nth-child(3),
.chiffrage-page .articles-table-wrapper td:nth-child(3),
.chiffrage-page .articles-table-wrapper th:nth-child(4),
.chiffrage-page .articles-table-wrapper td:nth-child(4),
.chiffrage-page .articles-table-wrapper th:nth-child(7),
.chiffrage-page .articles-table-wrapper td:nth-child(7) {
  text-align: center;
}

.chiffrage-page .articles-table-wrapper th:nth-child(5),
.chiffrage-page .articles-table-wrapper td:nth-child(5),
.chiffrage-page .articles-table-wrapper th:nth-child(6),
.chiffrage-page .articles-table-wrapper td:nth-child(6) {
  text-align: right;
  padding-right: 1rem;
}

/* Le bouton supprimer suit l'alignement centre de sa cellule (pas de flottant). */
.chiffrage-page .articles-table-wrapper td:nth-child(7) .delete-button {
  float: none;
  margin: 0 auto;
}

/* Bouton d'ajout, integre au tableau comme cote acheteur BC. Scope a la page : la classe vient de la
   feuille du BC, la regler sans scope changerait aussi le bon de commande.
   \`box-sizing\` + \`max-width\` : la base globale (CreationArticle.css) le met en \`width: 100%\`, et le
   \`margin\` du wrapper l'aurait fait deborder de sa boite — le BC corrige exactement pareil. */
.chiffrage-page .articles-table-wrapper .add-article-button {
  box-sizing: border-box;
  max-width: calc(100% - 2rem);
  /* Meme marge que le BC : le bouton est DANS le tableau, c'est le wrapper qui l'espace du total. */
  margin: 1rem;
}

/* Sans article, le tableau se resume a ce message : il porte l'espace que les lignes donneraient. */
.chiffrage-page .articles-table-wrapper .chiffrage-placeholder {
  margin: 0;
  padding: 2.4rem 1rem;
  text-align: center;
  color: #6b7280;
}

/* Le code dans le declencheur : en gras et en monospace, comme partout ailleurs dans la feature.
   Il ressort de la ligne de detail qui reste, elle, en gris. */
.chiffrage-encours-trigger-code {
  font-family: monospace;
  font-weight: 700;
  color: #374151;
}

/* Barre d'actions du chiffrage : elle vivait dans le pied du catalogue inline, qui n'existe plus.
   Elle se pose maintenant sous la table, alignee a droite comme le reste de la page. */
.chiffrage-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.2rem 0 0;
  border-top: 1px solid #e5e7eb;
  margin-top: 1.2rem;
}

/* Loader circulaire affiche A LA PLACE de la croix pendant l'enregistrement d'un retrait.
   Geometrie identique a celle du BC (.opbc .delete-spinner, SuiviOperationBCV2.css) : meme rendu
   d'un ecran a l'autre. \`currentColor\` reprend la couleur du bouton, donc aucune couleur ajoutee
   a la palette. Le keyframes est prefixe pour ne pas entrer en collision avec celui du BC — le CSS
   est global et deux @keyframes de meme nom se remplacent silencieusement. */
.chiffrage-articles .delete-spinner,
.chiffrage-table .delete-spinner,
.delete-button .delete-spinner {
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: chiffrage-delete-spin 0.6s linear infinite;
  vertical-align: middle;
}

@keyframes chiffrage-delete-spin {
  to {
    transform: rotate(360deg);
  }
}

/* Le composant Button porte \`align-self: stretch\` : dans cette rangee il s'etirerait sur toute la
   hauteur (label compris). On le recale en bas, a la hauteur des champs (3.8rem). */
.chiffrage-toolbar > .button {
  align-self: flex-end;
  height: 3.8rem;
  flex-shrink: 0;
  white-space: nowrap;
}

.chiffrage-toolbar > .chiffrage-encours-select {
  align-self: flex-end;
  flex-shrink: 0;
}

/* Menu de reprise custom : declencheur cale sur la hauteur des champs (4rem), panneau en surcouche.
   \`position: relative\` sur la racine ancre le panneau ; z-index modeste, on est dans le flux de la
   page (aucune modale ici). */
/* La largeur se joue ICI, sur la racine du composant : c'est elle l'element flex de la barre. La poser
   sur le declencheur serait sans effet — cette racine n'est pas un conteneur flex. */
.chiffrage-toolbar > .chiffrage-encours {
  position: relative;
  align-self: flex-end;
  /* Prend TOUT le reste de la barre : les deux boutons qui l'encadrent gardent leur largeur propre
     (\`flex-shrink: 0\`), le menu absorbe le solde. Pas de \`max-width\` : le brider laisserait un vide
     entre lui et le bouton de droite, qui ne serait alors plus vraiment "tout a droite".
     La base est 0 et NON \`auto\` : \`auto\` fait lire au menu la largeur de son CONTENU comme taille de
     base, donc un libelle long gonflait la base, la ligne ne tenait plus et la barre enroulait. A 0,
     sa largeur ne depend plus que de la place restante — le contenu ne vote pas. C'est l'ellipse du
     declencheur qui absorbe le trop-plein.
     Le \`min-width\` explicite reste, et n'est pas le coupable : il neutralise deja le \`min-width: auto\`
     (base sur le contenu) des elements flex. Il ne joue que sur la largeur de la fenetre — un plancher
     de lisibilite, sous lequel la barre enroule pour de bonnes raisons. */
  flex: 1 1;
  min-width: 24rem;
}

.chiffrage-encours-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  /* Hauteur EXACTE des boutons de la barre (\`.chiffrage-toolbar > .button\`, 3.8rem) : le declencheur
     s'aligne sur eux. Les deux lignes du libelle tiennent dedans par leurs \`line-height\` serres — la
     hauteur est la contrainte, le texte s'y plie (cf. .chiffrage-encours-trigger-text). */
  height: 3.8rem;
  /* Epouse la racine, qui porte la largeur. */
  width: 100%;
  padding: 0 1.2rem;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  color: #2c3948;
  font-size: 12px;
  cursor: pointer;
}

.chiffrage-encours-trigger:disabled {
  background-color: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
}

/* DEUX lignes : le nom, puis tout le detail en dessous. Le declencheur garde la hauteur des boutons
   (3.8rem) — ce sont donc les \`line-height\` qui cedent, pas la boite : 1.6 + 1.4 = 3rem de texte,
   qui tient dans 3.8rem moins la bordure. \`min-width: 0\` est indispensable — sans lui, un enfant flex
   refuse de passer sous sa largeur intrinseque et l'ellipse ne mord jamais : c'est la barre entiere
   qui deborderait a la place. */
.chiffrage-encours-trigger-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 0;
  overflow: hidden;
  text-align: left;
}

.chiffrage-encours-trigger-text .chiffrage-encours-option-nom,
.chiffrage-encours-trigger-suite {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chiffrage-encours-trigger-text .chiffrage-encours-option-nom {
  font-size: 1.3rem;
  line-height: 1.6rem;
}

.chiffrage-encours-trigger-suite {
  font-size: 1.1rem;
  line-height: 1.4rem;
  color: #6b7280;
}

/* Chevron : pointe vers le bas au repos, se retourne vers le haut a l'ouverture. */
.chiffrage-encours-chevron {
  color: #6b7280;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.chiffrage-encours-chevron--open {
  transform: rotate(180deg);
}

/* Panneau volontairement PLUS LARGE que le declencheur : la ligne de detail (date, lots, articles,
   prix, contrat) doit tenir sans etre tronquee. Il deborde donc a droite du declencheur. */
.chiffrage-encours-panel {
  position: absolute;
  top: calc(100% + 0.4rem);
  left: 0;
  z-index: 20;
  /* Epouse le declencheur (la racine porte la largeur) : \`width: max-content\` le laissait se caler
     sur son plus long libelle, donc plus etroit OU plus large que le select selon le contenu — un
     panneau desaligne de ce qu'il ouvre. Les 3 lignes par entree sont conservees : c'est la hauteur
     qui s'adapte, pas l'information qu'on retire. */
  width: 100%;
  max-height: 36rem;
  overflow-y: auto;
  margin: 0;
  padding: 0.4rem;
  list-style: none;
  background-color: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

/* Une entree = l'option (2 lignes) + le bouton de copie, cote a cote (boutons FRERES). */
.chiffrage-encours-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  border-radius: 0.6rem;
}

.chiffrage-encours-item:hover {
  background-color: #f9fafb;
}

/* Entree courante : gris de selection de l'app (#f8f9fa), sans liseré ni bordure orange. */
.chiffrage-encours-item--current {
  background-color: #f8f9fa;
}

.chiffrage-encours-option {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  flex: 1 1;
  min-width: 0;
  padding: 0.9rem 1rem;
  border: none;
  border-radius: 0.6rem;
  background: none;
  text-align: left;
  cursor: pointer;
}

.chiffrage-encours-option-nom {
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3948;
}

.chiffrage-encours-option-details {
  font-size: 1.2rem;
  color: #6b7280;
  white-space: nowrap;
}

/* Code + icone de copie : meme accuse de reception que la liste (icone -> check pendant 2s). */
/* Gris repris A L'IDENTIQUE du variant \`cancel\` du composant Button (#6b7280, hover #4b5563, texte
   blanc) : ce bouton est du markup natif, on ne reinvente pas sa nuance. */
.chiffrage-encours-copy {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex-shrink: 0;
  margin-right: 0.6rem;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.6rem;
  /* Orange de la charte : le code est CE que le presta vient chercher ici, il porte l'action. */
  background-color: #f97316;
  color: #fff;
  cursor: pointer;
}

.chiffrage-encours-copy:hover {
  background-color: #ea580c;
}

/* L'icone de copie porte un fill sombre EN DUR dans le SVG (#2C3948) : illisible sur le gris, on la
   repeint en blanc (le fill CSS l'emporte sur l'attribut de presentation). Le CHECK, lui, n'est pas
   repeint : il garde le vert natif de son fichier (#16A34A). */
.chiffrage-encours-copy .chiffrage-encours-copy-icon,
.chiffrage-encours-copy .chiffrage-encours-copy-icon path {
  fill: #fff;
}

/* Confirmation lisible de la copie (pas seulement l'icone). */
.chiffrage-encours-copie {
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
}

.chiffrage-encours-copy svg {
  width: 1.4rem;
  height: 1.4rem;
  flex-shrink: 0;
}

/* Meme rendu que le code dans la liste (\`.commandes-page .chiffrage-code\`) : monospace + interlettre,
   pour la lisibilite des 8 caracteres Crockford. Le code vit dans le bouton gris -> texte blanc. */
.chiffrage-encours-code {
  font-family: monospace;
  letter-spacing: 1px;
  font-size: 1.2rem;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
}

.chiffrage-toolbar-lots {
  display: flex;
  gap: 2.4rem;
  flex-wrap: wrap;
  align-items: flex-end;
}

.chiffrage-lot-readonly {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 22rem;
}

.chiffrage-lot-readonly-label {
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  color: #9ca3af;
}

.chiffrage-lot-readonly-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #374151;
}

.chiffrage-toolbar-hint {
  margin: 0;
  font-size: 1.4rem;
  color: #6b7280;
}

/* Champs calques sur les filtres de l'annuaire (.annuaire-filters / .filter-dropdown) : meme
   structure label-au-dessus, label 500 / #606060 sans capitales, et surtout AUCUN style impose au
   select -> il herite du style global (App.css), exactement comme l'annuaire dont la regle select est
   commentee. On garde juste le focus orange du design system.
   min-width contenu (17rem au lieu des 200px de l'annuaire) : ici les champs partagent la ligne avec
   trois actions, il faut que tout tienne. */
.chiffrage-filter {
  display: flex;
  flex-direction: column;
  min-width: 17rem;
  flex: 0 1 auto;
}

.chiffrage-filter label {
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #606060;
}

/* Hauteur figee : le select global tombe a ~4rem. On l'explicite pour que champs, menu de reprise et
   boutons se calent au meme niveau sur la rangee. */
.chiffrage-filter select,
.chiffrage-filter input {
  height: 4rem;
}

.chiffrage-filter select:focus,
.chiffrage-filter input:focus {
  border-color: #f97316;
  outline: none;
}

.chiffrage-filter select:disabled,
.chiffrage-filter input:disabled {
  background-color: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
}

.chiffrage-filter--libelle {
  flex: 1 1;
  min-width: 26rem;
}

.chiffrage-toolbar-actions {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
}

/* Menu de reprise d'un chiffrage en cours : cale sur la hauteur des boutons du voisinage. */
.chiffrage-encours-select {
  height: 3.8rem;
  max-width: 32rem;
  padding: 0 1rem;
  font-size: 1.4rem;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0.8rem;
  background-color: #ffffff;
  cursor: pointer;
}

.chiffrage-encours-select:disabled {
  background-color: #f3f4f6;
  color: #6b7280;
  cursor: not-allowed;
}

.chiffrage-encours-select:focus {
  border-color: #f97316;
  outline: none;
}

.chiffrage-rang-info {
  margin: 0.5rem 0 1.5rem;
  font-size: 1.4rem;
  color: #595959;
  font-weight: 500;
}

.chiffrage-placeholder {
  color: #6b7280;
  font-size: 1.5rem;
  text-align: center;
  padding: 4rem 0;
}

/* ---- Catalogue INLINE ---- */

.chiffrage-list {
  margin-top: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  background-color: #ffffff;
  overflow: hidden;
}

.chiffrage-list-search {
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
}

/* Recherche a gauche, rappel des lots a droite. La SearchBar prend l'espace restant ; le rappel ne se
   comprime pas (il doit rester lisible). */
.chiffrage-list-search-row {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.chiffrage-list-search-row .search-bar {
  flex: 1 1;
  width: auto;
}

.chiffrage-lots-rappel {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex-shrink: 0;
  font-size: 1.3rem;
  color: #374151;
}

.chiffrage-lot-rappel-label {
  color: #6b7280;
}

.chiffrage-search-info {
  margin-top: 0.8rem;
  font-size: 1.3rem;
  color: #6b7280;
}

.chiffrage-list-content {
  max-height: 60rem;
  overflow-y: auto;
}

.chiffrage-list-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  padding: 4rem 2rem;
  text-align: center;
  color: #6b7280;
  font-size: 1.5rem;
}

.chiffrage-list-state--error {
  color: #b91c1c;
}

.chiffrage-list-spinner {
  width: 3.2rem;
  height: 3.2rem;
  border: 0.4rem solid #f3f4f6;
  border-top-color: #f97316;
  border-radius: 50%;
  animation: chiffrage-spin 0.8s linear infinite;
}

@keyframes chiffrage-spin {
  to {
    transform: rotate(360deg);
  }
}

.chiffrage-article-container {
  border-bottom: 1px solid #f3f4f6;
}

.chiffrage-article-row {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1.4rem 1.8rem;
}

/* Ligne retenue : STRICTEMENT le meme traitement que la selection d'articles cote acheteur
   (ModalArticles \`.article-row.article-added\`) — fond gris #f8f9fa et liseré orange en accent.
   L'orange est une couleur d'accent de la charte, pas une couleur de fond. */
.chiffrage-article-row--added {
  background-color: #f8f9fa;
  border-left: 4px solid #f97316;
}

.chiffrage-article-code {
  flex: 0 0 auto;
  min-width: 11rem;
  font-size: 1.2rem;
  font-weight: 600;
  color: #6b7280;
}

.chiffrage-article-info {
  flex: 1 1;
  min-width: 0;
}

.chiffrage-article-nom {
  margin: 0 0 0.4rem;
  font-size: 1.5rem;
  font-weight: 600;
  color: #374151;
}

.chiffrage-article-prix {
  margin: 0;
  font-size: 1.3rem;
  color: #6b7280;
}

.chiffrage-prix-value {
  font-weight: 700;
  color: #f97316;
}

.chiffrage-prix-placeholder {
  font-style: italic;
}

.chiffrage-quantity-controls {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: 0 0 auto;
}

.chiffrage-quantity-btn {
  width: 3.2rem;
  height: 3.2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  line-height: 1;
  color: #374151;
  background-color: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 0.6rem;
  cursor: pointer;
}

.chiffrage-quantity-btn:hover:not(:disabled) {
  border-color: #f97316;
  color: #f97316;
}

.chiffrage-quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Colonne quantite elargie : doit afficher un entier au format FR complet, ex. "10 000 000",
   sans troncature ni saut de la grille des lignes. */
.chiffrage-quantity-input {
  width: 16rem;
  height: 3.2rem;
  padding: 0 0.8rem;
  text-align: center;
  font-size: 1.4rem;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 0.6rem;
}

.chiffrage-quantity-input:focus {
  border-color: #f97316;
  outline: none;
}

.chiffrage-quantity-readonly {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 0 0 auto;
  /* Meme empreinte que la colonne editable pour afficher un entier FR complet ("10 000 000"). */
  min-width: 16rem;
}

.chiffrage-quantity-readonly-label {
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  color: #9ca3af;
}

.chiffrage-quantity-readonly-value {
  font-size: 1.6rem;
  font-weight: 700;
  color: #374151;
}

.chiffrage-article-total {
  flex: 0 0 auto;
  min-width: 9rem;
  text-align: right;
  font-size: 1.5rem;
  font-weight: 700;
  color: #595959;
}

/* Details expandables : description + seuils + grille par tranche. */
.chiffrage-article-details {
  padding: 1.6rem 1.8rem 2rem;
  background-color: #f9fafb;
  border-top: 1px solid #f3f4f6;
}

.chiffrage-article-description {
  margin: 0 0 1.2rem;
  font-size: 1.3rem;
  color: #4b5563;
}

.chiffrage-article-meta {
  display: flex;
  gap: 3rem;
  margin-bottom: 1.4rem;
}

.chiffrage-article-meta > div {
  display: flex;
  flex-direction: column;
}

.chiffrage-meta-label {
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  color: #9ca3af;
}

.chiffrage-meta-value {
  font-size: 1.4rem;
  font-weight: 600;
  color: #374151;
}

.chiffrage-grille-titre {
  margin: 0 0 1rem;
  font-size: 1.4rem;
  font-weight: 700;
  color: #595959;
}

.chiffrage-grille-scroll {
  overflow-x: auto;
}

.chiffrage-grille-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.3rem;
}

.chiffrage-grille-table th,
.chiffrage-grille-table td {
  padding: 0.8rem 1rem;
  border: 1px solid #e5e7eb;
  text-align: left;
  color: #374151;
}

.chiffrage-grille-table thead th {
  background-color: rgba(215, 217, 217, 0.25);
  font-weight: 600;
  color: #595959;
}

.chiffrage-grille-rang {
  white-space: nowrap;
  font-weight: 700;
  color: #595959;
}

.chiffrage-grille-info {
  margin: 1.5rem;
}

.chiffrage-list-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
  padding: 1.6rem 1.8rem;
  border-top: 1px solid #e5e7eb;
  background-color: #f9fafb;
}

.chiffrage-footer-count {
  font-size: 1.4rem;
  color: #6b7280;
}

.chiffrage-footer-total {
  font-size: 1.5rem;
  color: #374151;
}

.chiffrage-footer-total-amount {
  font-weight: 700;
  color: #595959;
}

/* ---- Pied d'actions (mockup) : total + boite code + boutons, sur une seule barre ---- */

/* Le total ayant rejoint le pied du catalogue, cette barre ne porte plus que les actions : elles
   restent alignees a DROITE (\`space-between\` avec un seul enfant les collait a gauche). */
.chiffrage-footer-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.5rem;
  flex-wrap: wrap;
  margin: 2rem 0;
}

.chiffrage-footer-left {
  display: flex;
  align-items: center;
  gap: 1.6rem;
  flex-wrap: wrap;
}

.chiffrage-footer-total-ht {
  font-size: 1.6rem;
  color: #374151;
}

.chiffrage-footer-total-ht span {
  font-weight: 700;
  color: #595959;
}

/* Bouton "code genere" du pied : variant \`cancel\` du composant Button (gris #6b7280), aligne sur le
   bouton de copie du menu de reprise. */
/* Rendu aux DEUX bouts de la page (haut et bas), plus grand que les boutons voisins : c'est la seule
   chose que le presta vient chercher ici, elle doit se voir sans etre cherchee. */
.chiffrage-code-btn {
  gap: 0.8rem;
  padding: 0.9rem 1.7rem;
}

/* Le code lui-meme : monospace comme dans la liste et le menu de reprise (8 caracteres Crockford),
   mais nettement plus gros — c'est la valeur a lire et a recopier. */
.chiffrage-code-btn-value {
  font-family: monospace;
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: 2px;
}

.chiffrage-code-btn-copie {
  font-size: 1.1rem;
  font-weight: 600;
}

/* L'icone est rendue DANS le label (pour la poser a droite), elle n'a donc pas le wrapper
   \`.button-icon\` : la regle \`!important\` du variant ne l'atteint pas et c'est ici qu'on la colorise.
   Le fill CSS l'emporte sur l'attribut de presentation du SVG. */
.chiffrage-code-btn-icon,
.chiffrage-code-btn-icon path {
  width: 1.6rem;
  height: 1.6rem;
  fill: #fff;
}

/* Le check reste vert (comme dans le menu de reprise). */
.chiffrage-code-btn-icon--check,
.chiffrage-code-btn-icon--check path {
  fill: #16A34A;
}

/* Boite code (mockup) : pastille cliquable pour copier le code. Fond gris de la charte ; l'orange
   reste en bordure (accent), jamais en fond. */
.chiffrage-code-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.8rem 1.4rem;
  border: 2px solid #f97316;
  border-radius: 0.8rem;
  background-color: #f8f9fa;
  cursor: pointer;
}

.chiffrage-code-pill-label {
  font-size: 1.1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05rem;
  color: #595959;
}

.chiffrage-code-pill-value {
  font-family: 'Courier New', Courier, monospace;
  font-size: 1.8rem;
  font-weight: 700;
  letter-spacing: 0.3rem;
  color: #f97316;
}

.chiffrage-footer-buttons {
  display: flex;
  gap: 1.2rem;
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .chiffrage-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .chiffrage-toolbar-actions {
    justify-content: flex-start;
  }

  .chiffrage-footer-bar {
    flex-direction: column;
    align-items: stretch;
  }

  .chiffrage-article-row {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chiffrage/Chiffrage.css"],"names":[],"mappings":"AAAA;qGACqG;;AAErG;EACE,WAAW;EACX,aAAa;EACb,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;kGACkG;AAClG;;gGAEgG;AAChG;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;kGAKkG;AAClG;EACE,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;qCAIqC;AACrC;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;;;;EAIE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;;;8FAG8F;AAC9F;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kGAAkG;EAClG,YAAY;AACd;;AAEA,oGAAoG;AACpG;EACE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;+DAC+D;AAC/D;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;uFACuF;AACvF;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;;;6EAI6E;AAC7E;;;EAGE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,qDAAqD;EACrD,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;oFACoF;AACpF;EACE,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;8BAE8B;AAC9B;qFACqF;AACrF;EACE,kBAAkB;EAClB,oBAAoB;EACpB;;;;;;;;;0EASwE;EACxE,SAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT;;0FAEwF;EACxF,cAAc;EACd,4CAA4C;EAC5C,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;gCAIgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mFAAmF;AACnF;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;2FAC2F;AAC3F;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,WAAW;EACX;;;oDAGkD;EAClD,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,yFAAyF;AACzF;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2FAA2F;AAC3F;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+FAA+F;AAC/F;2EAC2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,8FAA8F;EAC9F,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;+DAE+D;AAC/D;;EAEE,UAAU;AACZ;;AAEA,8DAA8D;AAC9D;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;mGACmG;AACnG;EACE,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;;;4CAK4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;oDACoD;AACpD;;EAEE,YAAY;AACd;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA,4FAA4F;AAC5F;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,+BAA+B;;AAE/B;EACE,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;2CAC2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;6EAE6E;AAC7E;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;qDACqD;AACrD;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,8FAA8F;EAC9F,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qEAAqE;AACrE;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0FAA0F;;AAE1F;0FAC0F;AAC1F;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;wCACwC;AACxC;kFACkF;AAClF;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;qEACqE;AACrE;EACE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;iEAEiE;AACjE;;EAEE,aAAa;EACb,cAAc;EACd,UAAU;AACZ;;AAEA,yDAAyD;AACzD;;EAEE,aAAa;AACf;;AAEA;+CAC+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Page Chiffrage (prestataire) : composition d'un devis pre-etabli, INLINE (pleine page). Palette\n   fermee du design system : headers #595959, primaire #f97316, texte #374151. Echelle 1rem = 10px. */\n\n.chiffrage-page {\n  width: 100%;\n  padding: 2rem;\n  color: #374151;\n}\n\n/* En-tete : titre + retour. */\n.chiffrage-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n  margin: 2rem 0 1.5rem;\n}\n\n.chiffrage-title {\n  margin: 0;\n  font-size: 2.2rem;\n  font-weight: 700;\n  color: #595959;\n}\n\n.chiffrage-feedback {\n  margin: 1.5rem 0;\n}\n\n/* Ligne du haut (mockup) : rappel en lecture seule des lots retenus (a gauche) + actions de la page\n   (a droite : nouveau chiffrage, reprise d'un chiffrage en cours, acces a tous les chiffrages). */\n/* Rangee unique : les 3 champs ET les 3 actions. `align-items: flex-end` cale les actions au niveau\n   des CHAMPS et non des labels (les champs sont des colonnes label + controle). Plus de\n   `justify-content: space-between` : il ecartait les deux anciens sous-groupes en deux blocs. */\n.chiffrage-toolbar {\n  display: flex;\n  align-items: flex-end;\n  gap: 1.2rem;\n  flex-wrap: wrap;\n  margin: 1.5rem 0;\n}\n\n/* ---------------------------------------------------------------------------------------------\n   Table des articles. Les classes viennent du BC (`.articles-table-*`), mais son ALIGNEMENT est\n   scope a la page cote BC (`.opbc …` dans SuiviOperationBCV2.css) — rien ne s'appliquait donc ici,\n   d'ou des en-tetes desynchronises du contenu. Ce scope est deliberatif dans ce projet : chaque page\n   cale ses propres colonnes (`.opbc`, `.scbc`…). On suit la convention, avec les MEMES colonnes.\n   --------------------------------------------------------------------------------------------- */\n.chiffrage-page .articles-table-wrapper {\n  overflow-x: hidden;\n}\n\n.chiffrage-page .articles-table-wrapper th,\n.chiffrage-page .articles-table-wrapper td {\n  overflow-wrap: break-word;\n}\n\n/* Les MEMES regles frappent thead ET tbody : l'en-tete ne peut donc pas se desynchroniser de son\n   contenu, et ca surclasse la regle globale qui forcait les en-tetes a gauche. Vaut pour la table en\n   lecture seule (6 colonnes) comme editable (7, +Actions).\n   col1 N°Ref + col2 Description = gauche ; col3 Unite + col4 Quantite + col7 Actions = centre ;\n   col5 Prix + col6 Total = droite. */\n.chiffrage-page .articles-table-wrapper th:nth-child(1),\n.chiffrage-page .articles-table-wrapper td:nth-child(1),\n.chiffrage-page .articles-table-wrapper th:nth-child(2),\n.chiffrage-page .articles-table-wrapper td:nth-child(2) {\n  text-align: left;\n}\n\n.chiffrage-page .articles-table-wrapper th:nth-child(3),\n.chiffrage-page .articles-table-wrapper td:nth-child(3),\n.chiffrage-page .articles-table-wrapper th:nth-child(4),\n.chiffrage-page .articles-table-wrapper td:nth-child(4),\n.chiffrage-page .articles-table-wrapper th:nth-child(7),\n.chiffrage-page .articles-table-wrapper td:nth-child(7) {\n  text-align: center;\n}\n\n.chiffrage-page .articles-table-wrapper th:nth-child(5),\n.chiffrage-page .articles-table-wrapper td:nth-child(5),\n.chiffrage-page .articles-table-wrapper th:nth-child(6),\n.chiffrage-page .articles-table-wrapper td:nth-child(6) {\n  text-align: right;\n  padding-right: 1rem;\n}\n\n/* Le bouton supprimer suit l'alignement centre de sa cellule (pas de flottant). */\n.chiffrage-page .articles-table-wrapper td:nth-child(7) .delete-button {\n  float: none;\n  margin: 0 auto;\n}\n\n/* Bouton d'ajout, integre au tableau comme cote acheteur BC. Scope a la page : la classe vient de la\n   feuille du BC, la regler sans scope changerait aussi le bon de commande.\n   `box-sizing` + `max-width` : la base globale (CreationArticle.css) le met en `width: 100%`, et le\n   `margin` du wrapper l'aurait fait deborder de sa boite — le BC corrige exactement pareil. */\n.chiffrage-page .articles-table-wrapper .add-article-button {\n  box-sizing: border-box;\n  max-width: calc(100% - 2rem);\n  /* Meme marge que le BC : le bouton est DANS le tableau, c'est le wrapper qui l'espace du total. */\n  margin: 1rem;\n}\n\n/* Sans article, le tableau se resume a ce message : il porte l'espace que les lignes donneraient. */\n.chiffrage-page .articles-table-wrapper .chiffrage-placeholder {\n  margin: 0;\n  padding: 2.4rem 1rem;\n  text-align: center;\n  color: #6b7280;\n}\n\n/* Le code dans le declencheur : en gras et en monospace, comme partout ailleurs dans la feature.\n   Il ressort de la ligne de detail qui reste, elle, en gris. */\n.chiffrage-encours-trigger-code {\n  font-family: monospace;\n  font-weight: 700;\n  color: #374151;\n}\n\n/* Barre d'actions du chiffrage : elle vivait dans le pied du catalogue inline, qui n'existe plus.\n   Elle se pose maintenant sous la table, alignee a droite comme le reste de la page. */\n.chiffrage-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.2rem 0 0;\n  border-top: 1px solid #e5e7eb;\n  margin-top: 1.2rem;\n}\n\n/* Loader circulaire affiche A LA PLACE de la croix pendant l'enregistrement d'un retrait.\n   Geometrie identique a celle du BC (.opbc .delete-spinner, SuiviOperationBCV2.css) : meme rendu\n   d'un ecran a l'autre. `currentColor` reprend la couleur du bouton, donc aucune couleur ajoutee\n   a la palette. Le keyframes est prefixe pour ne pas entrer en collision avec celui du BC — le CSS\n   est global et deux @keyframes de meme nom se remplacent silencieusement. */\n.chiffrage-articles .delete-spinner,\n.chiffrage-table .delete-spinner,\n.delete-button .delete-spinner {\n  display: inline-block;\n  width: 1em;\n  height: 1em;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: chiffrage-delete-spin 0.6s linear infinite;\n  vertical-align: middle;\n}\n\n@keyframes chiffrage-delete-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Le composant Button porte `align-self: stretch` : dans cette rangee il s'etirerait sur toute la\n   hauteur (label compris). On le recale en bas, a la hauteur des champs (3.8rem). */\n.chiffrage-toolbar > .button {\n  align-self: flex-end;\n  height: 3.8rem;\n  flex-shrink: 0;\n  white-space: nowrap;\n}\n\n.chiffrage-toolbar > .chiffrage-encours-select {\n  align-self: flex-end;\n  flex-shrink: 0;\n}\n\n/* Menu de reprise custom : declencheur cale sur la hauteur des champs (4rem), panneau en surcouche.\n   `position: relative` sur la racine ancre le panneau ; z-index modeste, on est dans le flux de la\n   page (aucune modale ici). */\n/* La largeur se joue ICI, sur la racine du composant : c'est elle l'element flex de la barre. La poser\n   sur le declencheur serait sans effet — cette racine n'est pas un conteneur flex. */\n.chiffrage-toolbar > .chiffrage-encours {\n  position: relative;\n  align-self: flex-end;\n  /* Prend TOUT le reste de la barre : les deux boutons qui l'encadrent gardent leur largeur propre\n     (`flex-shrink: 0`), le menu absorbe le solde. Pas de `max-width` : le brider laisserait un vide\n     entre lui et le bouton de droite, qui ne serait alors plus vraiment \"tout a droite\".\n     La base est 0 et NON `auto` : `auto` fait lire au menu la largeur de son CONTENU comme taille de\n     base, donc un libelle long gonflait la base, la ligne ne tenait plus et la barre enroulait. A 0,\n     sa largeur ne depend plus que de la place restante — le contenu ne vote pas. C'est l'ellipse du\n     declencheur qui absorbe le trop-plein.\n     Le `min-width` explicite reste, et n'est pas le coupable : il neutralise deja le `min-width: auto`\n     (base sur le contenu) des elements flex. Il ne joue que sur la largeur de la fenetre — un plancher\n     de lisibilite, sous lequel la barre enroule pour de bonnes raisons. */\n  flex: 1 1 0;\n  min-width: 24rem;\n}\n\n.chiffrage-encours-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  /* Hauteur EXACTE des boutons de la barre (`.chiffrage-toolbar > .button`, 3.8rem) : le declencheur\n     s'aligne sur eux. Les deux lignes du libelle tiennent dedans par leurs `line-height` serres — la\n     hauteur est la contrainte, le texte s'y plie (cf. .chiffrage-encours-trigger-text). */\n  height: 3.8rem;\n  /* Epouse la racine, qui porte la largeur. */\n  width: 100%;\n  padding: 0 1.2rem;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  color: #2c3948;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.chiffrage-encours-trigger:disabled {\n  background-color: #f3f4f6;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n/* DEUX lignes : le nom, puis tout le detail en dessous. Le declencheur garde la hauteur des boutons\n   (3.8rem) — ce sont donc les `line-height` qui cedent, pas la boite : 1.6 + 1.4 = 3rem de texte,\n   qui tient dans 3.8rem moins la bordure. `min-width: 0` est indispensable — sans lui, un enfant flex\n   refuse de passer sous sa largeur intrinseque et l'ellipse ne mord jamais : c'est la barre entiere\n   qui deborderait a la place. */\n.chiffrage-encours-trigger-text {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  min-width: 0;\n  overflow: hidden;\n  text-align: left;\n}\n\n.chiffrage-encours-trigger-text .chiffrage-encours-option-nom,\n.chiffrage-encours-trigger-suite {\n  display: block;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chiffrage-encours-trigger-text .chiffrage-encours-option-nom {\n  font-size: 1.3rem;\n  line-height: 1.6rem;\n}\n\n.chiffrage-encours-trigger-suite {\n  font-size: 1.1rem;\n  line-height: 1.4rem;\n  color: #6b7280;\n}\n\n/* Chevron : pointe vers le bas au repos, se retourne vers le haut a l'ouverture. */\n.chiffrage-encours-chevron {\n  color: #6b7280;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.chiffrage-encours-chevron--open {\n  transform: rotate(180deg);\n}\n\n/* Panneau volontairement PLUS LARGE que le declencheur : la ligne de detail (date, lots, articles,\n   prix, contrat) doit tenir sans etre tronquee. Il deborde donc a droite du declencheur. */\n.chiffrage-encours-panel {\n  position: absolute;\n  top: calc(100% + 0.4rem);\n  left: 0;\n  z-index: 20;\n  /* Epouse le declencheur (la racine porte la largeur) : `width: max-content` le laissait se caler\n     sur son plus long libelle, donc plus etroit OU plus large que le select selon le contenu — un\n     panneau desaligne de ce qu'il ouvre. Les 3 lignes par entree sont conservees : c'est la hauteur\n     qui s'adapte, pas l'information qu'on retire. */\n  width: 100%;\n  max-height: 36rem;\n  overflow-y: auto;\n  margin: 0;\n  padding: 0.4rem;\n  list-style: none;\n  background-color: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 1rem;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n/* Une entree = l'option (2 lignes) + le bouton de copie, cote a cote (boutons FRERES). */\n.chiffrage-encours-item {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  border-radius: 0.6rem;\n}\n\n.chiffrage-encours-item:hover {\n  background-color: #f9fafb;\n}\n\n/* Entree courante : gris de selection de l'app (#f8f9fa), sans liseré ni bordure orange. */\n.chiffrage-encours-item--current {\n  background-color: #f8f9fa;\n}\n\n.chiffrage-encours-option {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  flex: 1;\n  min-width: 0;\n  padding: 0.9rem 1rem;\n  border: none;\n  border-radius: 0.6rem;\n  background: none;\n  text-align: left;\n  cursor: pointer;\n}\n\n.chiffrage-encours-option-nom {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #2c3948;\n}\n\n.chiffrage-encours-option-details {\n  font-size: 1.2rem;\n  color: #6b7280;\n  white-space: nowrap;\n}\n\n/* Code + icone de copie : meme accuse de reception que la liste (icone -> check pendant 2s). */\n/* Gris repris A L'IDENTIQUE du variant `cancel` du composant Button (#6b7280, hover #4b5563, texte\n   blanc) : ce bouton est du markup natif, on ne reinvente pas sa nuance. */\n.chiffrage-encours-copy {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  flex-shrink: 0;\n  margin-right: 0.6rem;\n  padding: 0.5rem 1rem;\n  border: none;\n  border-radius: 0.6rem;\n  /* Orange de la charte : le code est CE que le presta vient chercher ici, il porte l'action. */\n  background-color: #f97316;\n  color: #fff;\n  cursor: pointer;\n}\n\n.chiffrage-encours-copy:hover {\n  background-color: #ea580c;\n}\n\n/* L'icone de copie porte un fill sombre EN DUR dans le SVG (#2C3948) : illisible sur le gris, on la\n   repeint en blanc (le fill CSS l'emporte sur l'attribut de presentation). Le CHECK, lui, n'est pas\n   repeint : il garde le vert natif de son fichier (#16A34A). */\n.chiffrage-encours-copy .chiffrage-encours-copy-icon,\n.chiffrage-encours-copy .chiffrage-encours-copy-icon path {\n  fill: #fff;\n}\n\n/* Confirmation lisible de la copie (pas seulement l'icone). */\n.chiffrage-encours-copie {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.chiffrage-encours-copy svg {\n  width: 1.4rem;\n  height: 1.4rem;\n  flex-shrink: 0;\n}\n\n/* Meme rendu que le code dans la liste (`.commandes-page .chiffrage-code`) : monospace + interlettre,\n   pour la lisibilite des 8 caracteres Crockford. Le code vit dans le bouton gris -> texte blanc. */\n.chiffrage-encours-code {\n  font-family: monospace;\n  letter-spacing: 1px;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #fff;\n  white-space: nowrap;\n}\n\n.chiffrage-toolbar-lots {\n  display: flex;\n  gap: 2.4rem;\n  flex-wrap: wrap;\n  align-items: flex-end;\n}\n\n.chiffrage-lot-readonly {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  min-width: 22rem;\n}\n\n.chiffrage-lot-readonly-label {\n  font-size: 1.1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05rem;\n  color: #9ca3af;\n}\n\n.chiffrage-lot-readonly-value {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.chiffrage-toolbar-hint {\n  margin: 0;\n  font-size: 1.4rem;\n  color: #6b7280;\n}\n\n/* Champs calques sur les filtres de l'annuaire (.annuaire-filters / .filter-dropdown) : meme\n   structure label-au-dessus, label 500 / #606060 sans capitales, et surtout AUCUN style impose au\n   select -> il herite du style global (App.css), exactement comme l'annuaire dont la regle select est\n   commentee. On garde juste le focus orange du design system.\n   min-width contenu (17rem au lieu des 200px de l'annuaire) : ici les champs partagent la ligne avec\n   trois actions, il faut que tout tienne. */\n.chiffrage-filter {\n  display: flex;\n  flex-direction: column;\n  min-width: 17rem;\n  flex: 0 1 auto;\n}\n\n.chiffrage-filter label {\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #606060;\n}\n\n/* Hauteur figee : le select global tombe a ~4rem. On l'explicite pour que champs, menu de reprise et\n   boutons se calent au meme niveau sur la rangee. */\n.chiffrage-filter select,\n.chiffrage-filter input {\n  height: 4rem;\n}\n\n.chiffrage-filter select:focus,\n.chiffrage-filter input:focus {\n  border-color: #f97316;\n  outline: none;\n}\n\n.chiffrage-filter select:disabled,\n.chiffrage-filter input:disabled {\n  background-color: #f3f4f6;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.chiffrage-filter--libelle {\n  flex: 1;\n  min-width: 26rem;\n}\n\n.chiffrage-toolbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  flex-wrap: wrap;\n}\n\n/* Menu de reprise d'un chiffrage en cours : cale sur la hauteur des boutons du voisinage. */\n.chiffrage-encours-select {\n  height: 3.8rem;\n  max-width: 32rem;\n  padding: 0 1rem;\n  font-size: 1.4rem;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 0.8rem;\n  background-color: #ffffff;\n  cursor: pointer;\n}\n\n.chiffrage-encours-select:disabled {\n  background-color: #f3f4f6;\n  color: #6b7280;\n  cursor: not-allowed;\n}\n\n.chiffrage-encours-select:focus {\n  border-color: #f97316;\n  outline: none;\n}\n\n.chiffrage-rang-info {\n  margin: 0.5rem 0 1.5rem;\n  font-size: 1.4rem;\n  color: #595959;\n  font-weight: 500;\n}\n\n.chiffrage-placeholder {\n  color: #6b7280;\n  font-size: 1.5rem;\n  text-align: center;\n  padding: 4rem 0;\n}\n\n/* ---- Catalogue INLINE ---- */\n\n.chiffrage-list {\n  margin-top: 1rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  background-color: #ffffff;\n  overflow: hidden;\n}\n\n.chiffrage-list-search {\n  padding: 1.5rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n/* Recherche a gauche, rappel des lots a droite. La SearchBar prend l'espace restant ; le rappel ne se\n   comprime pas (il doit rester lisible). */\n.chiffrage-list-search-row {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n}\n\n.chiffrage-list-search-row .search-bar {\n  flex: 1;\n  width: auto;\n}\n\n.chiffrage-lots-rappel {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  flex-shrink: 0;\n  font-size: 1.3rem;\n  color: #374151;\n}\n\n.chiffrage-lot-rappel-label {\n  color: #6b7280;\n}\n\n.chiffrage-search-info {\n  margin-top: 0.8rem;\n  font-size: 1.3rem;\n  color: #6b7280;\n}\n\n.chiffrage-list-content {\n  max-height: 60rem;\n  overflow-y: auto;\n}\n\n.chiffrage-list-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.2rem;\n  padding: 4rem 2rem;\n  text-align: center;\n  color: #6b7280;\n  font-size: 1.5rem;\n}\n\n.chiffrage-list-state--error {\n  color: #b91c1c;\n}\n\n.chiffrage-list-spinner {\n  width: 3.2rem;\n  height: 3.2rem;\n  border: 0.4rem solid #f3f4f6;\n  border-top-color: #f97316;\n  border-radius: 50%;\n  animation: chiffrage-spin 0.8s linear infinite;\n}\n\n@keyframes chiffrage-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.chiffrage-article-container {\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.chiffrage-article-row {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  padding: 1.4rem 1.8rem;\n}\n\n/* Ligne retenue : STRICTEMENT le meme traitement que la selection d'articles cote acheteur\n   (ModalArticles `.article-row.article-added`) — fond gris #f8f9fa et liseré orange en accent.\n   L'orange est une couleur d'accent de la charte, pas une couleur de fond. */\n.chiffrage-article-row--added {\n  background-color: #f8f9fa;\n  border-left: 4px solid #f97316;\n}\n\n.chiffrage-article-code {\n  flex: 0 0 auto;\n  min-width: 11rem;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.chiffrage-article-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.chiffrage-article-nom {\n  margin: 0 0 0.4rem;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.chiffrage-article-prix {\n  margin: 0;\n  font-size: 1.3rem;\n  color: #6b7280;\n}\n\n.chiffrage-prix-value {\n  font-weight: 700;\n  color: #f97316;\n}\n\n.chiffrage-prix-placeholder {\n  font-style: italic;\n}\n\n.chiffrage-quantity-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex: 0 0 auto;\n}\n\n.chiffrage-quantity-btn {\n  width: 3.2rem;\n  height: 3.2rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  line-height: 1;\n  color: #374151;\n  background-color: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 0.6rem;\n  cursor: pointer;\n}\n\n.chiffrage-quantity-btn:hover:not(:disabled) {\n  border-color: #f97316;\n  color: #f97316;\n}\n\n.chiffrage-quantity-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Colonne quantite elargie : doit afficher un entier au format FR complet, ex. \"10 000 000\",\n   sans troncature ni saut de la grille des lignes. */\n.chiffrage-quantity-input {\n  width: 16rem;\n  height: 3.2rem;\n  padding: 0 0.8rem;\n  text-align: center;\n  font-size: 1.4rem;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 0.6rem;\n}\n\n.chiffrage-quantity-input:focus {\n  border-color: #f97316;\n  outline: none;\n}\n\n.chiffrage-quantity-readonly {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  flex: 0 0 auto;\n  /* Meme empreinte que la colonne editable pour afficher un entier FR complet (\"10 000 000\"). */\n  min-width: 16rem;\n}\n\n.chiffrage-quantity-readonly-label {\n  font-size: 1.1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05rem;\n  color: #9ca3af;\n}\n\n.chiffrage-quantity-readonly-value {\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #374151;\n}\n\n.chiffrage-article-total {\n  flex: 0 0 auto;\n  min-width: 9rem;\n  text-align: right;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #595959;\n}\n\n/* Details expandables : description + seuils + grille par tranche. */\n.chiffrage-article-details {\n  padding: 1.6rem 1.8rem 2rem;\n  background-color: #f9fafb;\n  border-top: 1px solid #f3f4f6;\n}\n\n.chiffrage-article-description {\n  margin: 0 0 1.2rem;\n  font-size: 1.3rem;\n  color: #4b5563;\n}\n\n.chiffrage-article-meta {\n  display: flex;\n  gap: 3rem;\n  margin-bottom: 1.4rem;\n}\n\n.chiffrage-article-meta > div {\n  display: flex;\n  flex-direction: column;\n}\n\n.chiffrage-meta-label {\n  font-size: 1.1rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05rem;\n  color: #9ca3af;\n}\n\n.chiffrage-meta-value {\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.chiffrage-grille-titre {\n  margin: 0 0 1rem;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #595959;\n}\n\n.chiffrage-grille-scroll {\n  overflow-x: auto;\n}\n\n.chiffrage-grille-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 1.3rem;\n}\n\n.chiffrage-grille-table th,\n.chiffrage-grille-table td {\n  padding: 0.8rem 1rem;\n  border: 1px solid #e5e7eb;\n  text-align: left;\n  color: #374151;\n}\n\n.chiffrage-grille-table thead th {\n  background-color: rgba(215, 217, 217, 0.25);\n  font-weight: 600;\n  color: #595959;\n}\n\n.chiffrage-grille-rang {\n  white-space: nowrap;\n  font-weight: 700;\n  color: #595959;\n}\n\n.chiffrage-grille-info {\n  margin: 1.5rem;\n}\n\n.chiffrage-list-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n  padding: 1.6rem 1.8rem;\n  border-top: 1px solid #e5e7eb;\n  background-color: #f9fafb;\n}\n\n.chiffrage-footer-count {\n  font-size: 1.4rem;\n  color: #6b7280;\n}\n\n.chiffrage-footer-total {\n  font-size: 1.5rem;\n  color: #374151;\n}\n\n.chiffrage-footer-total-amount {\n  font-weight: 700;\n  color: #595959;\n}\n\n/* ---- Pied d'actions (mockup) : total + boite code + boutons, sur une seule barre ---- */\n\n/* Le total ayant rejoint le pied du catalogue, cette barre ne porte plus que les actions : elles\n   restent alignees a DROITE (`space-between` avec un seul enfant les collait a gauche). */\n.chiffrage-footer-bar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 1.5rem;\n  flex-wrap: wrap;\n  margin: 2rem 0;\n}\n\n.chiffrage-footer-left {\n  display: flex;\n  align-items: center;\n  gap: 1.6rem;\n  flex-wrap: wrap;\n}\n\n.chiffrage-footer-total-ht {\n  font-size: 1.6rem;\n  color: #374151;\n}\n\n.chiffrage-footer-total-ht span {\n  font-weight: 700;\n  color: #595959;\n}\n\n/* Bouton \"code genere\" du pied : variant `cancel` du composant Button (gris #6b7280), aligne sur le\n   bouton de copie du menu de reprise. */\n/* Rendu aux DEUX bouts de la page (haut et bas), plus grand que les boutons voisins : c'est la seule\n   chose que le presta vient chercher ici, elle doit se voir sans etre cherchee. */\n.chiffrage-code-btn {\n  gap: 0.8rem;\n  padding: 0.9rem 1.7rem;\n}\n\n/* Le code lui-meme : monospace comme dans la liste et le menu de reprise (8 caracteres Crockford),\n   mais nettement plus gros — c'est la valeur a lire et a recopier. */\n.chiffrage-code-btn-value {\n  font-family: monospace;\n  font-size: 1.6rem;\n  font-weight: 700;\n  letter-spacing: 2px;\n}\n\n.chiffrage-code-btn-copie {\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n/* L'icone est rendue DANS le label (pour la poser a droite), elle n'a donc pas le wrapper\n   `.button-icon` : la regle `!important` du variant ne l'atteint pas et c'est ici qu'on la colorise.\n   Le fill CSS l'emporte sur l'attribut de presentation du SVG. */\n.chiffrage-code-btn-icon,\n.chiffrage-code-btn-icon path {\n  width: 1.6rem;\n  height: 1.6rem;\n  fill: #fff;\n}\n\n/* Le check reste vert (comme dans le menu de reprise). */\n.chiffrage-code-btn-icon--check,\n.chiffrage-code-btn-icon--check path {\n  fill: #16A34A;\n}\n\n/* Boite code (mockup) : pastille cliquable pour copier le code. Fond gris de la charte ; l'orange\n   reste en bordure (accent), jamais en fond. */\n.chiffrage-code-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.8rem;\n  padding: 0.8rem 1.4rem;\n  border: 2px solid #f97316;\n  border-radius: 0.8rem;\n  background-color: #f8f9fa;\n  cursor: pointer;\n}\n\n.chiffrage-code-pill-label {\n  font-size: 1.1rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05rem;\n  color: #595959;\n}\n\n.chiffrage-code-pill-value {\n  font-family: 'Courier New', Courier, monospace;\n  font-size: 1.8rem;\n  font-weight: 700;\n  letter-spacing: 0.3rem;\n  color: #f97316;\n}\n\n.chiffrage-footer-buttons {\n  display: flex;\n  gap: 1.2rem;\n  flex-wrap: wrap;\n}\n\n@media (max-width: 768px) {\n  .chiffrage-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .chiffrage-toolbar-actions {\n    justify-content: flex-start;\n  }\n\n  .chiffrage-footer-bar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .chiffrage-article-row {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
